<template>
    <div>
        <HeroMini 
        msg="Uberman Cycle" 
        subMsg="Six short, 20 minute naps throughout the day."/>
        <CycleCalculator msg="Uberman Sleeping Cycle" /> 
    </div>

</template>

<script>
import HeroMini from "@/components/calculator/HeroMini.vue";
import CycleCalculator from "@/components/calculator/CycleCalculator.vue";

export default {
  name: "UbermanCycle",

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Uberman Sleep-Cycle',
    // all titles will be injected into this template
    titleTemplate: '%s | Slumber Bear',
    meta: [
      {itemprop: 'name', content: 'Uberman Sleep-Cycle | Slumber Bear'},
      {itemprop: 'description', content: 'Six short, 20 minute naps throughout the day.'},
      {itemprop: 'image', content: 'https://i.imgur.com/lEHqYJ4.jpg'}
    ]
  },

  components: {
    HeroMini,
    CycleCalculator
  }
};
</script>

<style lang="scss">
@import "@/styles/global.scss";
</style>
